import { useQuery } from '@tanstack/react-query';
import { api, apiUrls } from '@/lib/apiClient';
import type { NonBusinessDay } from '@/types/model.types';

/** Replaces NonBusinessDayService, including the array-to-map reduction. */
export function useNonBusinessDays() {
  return useQuery({
    queryKey: ['non-business-days'],
    queryFn: async () => {
      const days = await api.get<NonBusinessDay[]>(apiUrls.nonBusinessDay, {
        operation: 'retrieving non-business days',
      });
      return Object.fromEntries(days.map((day) => [day.date, day])) as Record<
        string,
        NonBusinessDay
      >;
    },
    staleTime: 24 * 60 * 60_000, // the holiday calendar is fixed for the year
  });
}
